__turbopack_context__.v({
  "container": "OrderSummaryRows-module__Xj82Sq__container",
  "rowIcon": "OrderSummaryRows-module__Xj82Sq__rowIcon",
});
